(() => {
  const ATTRIBUTE_KEY = 'Rechtliche Hinweise bestätigt';
  const ATTRIBUTE_VALUE =
    'AGB akzeptiert; Widerrufsbelehrung und Datenschutz zur Kenntnis genommen';
  const ROOT_SELECTOR = '[data-nett-cart-consent]';

  let saveRequest = null;

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getElements() {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return null;

    return {
      root,
      input: root.querySelector('[data-nett-cart-consent-input]'),
      status: root.querySelector('[data-nett-cart-consent-status]'),
      error: root.querySelector('[data-nett-cart-consent-error]'),
      checkout: document.querySelector('[data-nett-cart-checkout]'),
      dynamicCheckout: document.querySelector('[data-nett-dynamic-checkout]'),
    };
  }

  function setMessage(elements, message = '') {
    if (!elements || !elements.error) return;
    elements.error.textContent = message;
    elements.error.hidden = !message;
  }

  function applyState({ saving = false } = {}) {
    const elements = getElements();
    if (!elements || !elements.input) return;

    const confirmed = elements.input.checked;
    const busy = elements.checkout?.getAttribute('aria-busy') === 'true';
    const empty = elements.checkout?.dataset.nettCartEmpty === 'true';
    const locked = !confirmed || saving;

    elements.root.classList.toggle('is-confirmed', confirmed && !saving);
    elements.root.classList.toggle('is-saving', saving);
    elements.input.disabled = saving;

    if (elements.status) {
      const statusText = saving
        ? 'Bestätigung wird gespeichert...'
        : confirmed
          ? 'Bestätigt. Du kannst jetzt sicher zur Kasse gehen.'
          : 'Bitte einmal bestätigen, um den Checkout freizuschalten.';
      if (elements.status.textContent !== statusText) {
        elements.status.textContent = statusText;
      }
    }

    if (elements.checkout) {
      const shouldDisable = empty || busy || locked;
      if (elements.checkout.disabled !== shouldDisable) {
        elements.checkout.disabled = shouldDisable;
      }
      elements.checkout.setAttribute(
        'aria-disabled',
        String(shouldDisable),
      );
    }

    if (elements.dynamicCheckout) {
      elements.dynamicCheckout.toggleAttribute('inert', locked);
      elements.dynamicCheckout.setAttribute('aria-disabled', String(locked));
    }
  }

  async function persistConsent(confirmed) {
    const response = await fetch(`${cartRoot()}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [ATTRIBUTE_KEY]: confirmed ? ATTRIBUTE_VALUE : '',
        },
      }),
    });

    if (!response.ok) {
      throw new Error(`Cart update failed (${response.status})`);
    }

    return response.json();
  }

  async function handleChange(event) {
    const input = event.currentTarget;
    const requestedState = input.checked;
    const elements = getElements();
    setMessage(elements);
    applyState({ saving: true });

    try {
      saveRequest = persistConsent(requestedState);
      await saveRequest;
      applyState();
    } catch (error) {
      console.error('Rechtliche Bestätigung konnte nicht gespeichert werden.', error);
      input.checked = !requestedState;
      setMessage(
        getElements(),
        'Die Bestätigung konnte nicht gespeichert werden. Bitte versuche es erneut.',
      );
      applyState();
    } finally {
      saveRequest = null;
    }
  }

  async function resetStoredConsent(elements) {
    if (!elements?.input || elements.root.dataset.nettCartConsentReset !== 'true') return;

    elements.root.dataset.nettCartConsentReset = 'false';
    elements.input.checked = false;
    setMessage(elements);
    applyState({ saving: true });

    try {
      saveRequest = persistConsent(false);
      await saveRequest;
    } catch (error) {
      console.error('Alte rechtliche Bestätigung konnte nicht gelöscht werden.', error);
      setMessage(
        getElements(),
        'Die vorherige Bestätigung konnte nicht zurückgesetzt werden. Bitte bestätige die Hinweise erneut.',
      );
    } finally {
      saveRequest = null;
      applyState();
    }
  }

  function guardCheckout(event) {
    const elements = getElements();
    if (!elements || !elements.input || elements.input.checked) return;

    const submitter = event.submitter;
    const isCheckoutSubmit =
      submitter &&
      (submitter.matches('[data-nett-cart-checkout]') ||
        submitter.getAttribute('name') === 'checkout');

    if (event.type === 'submit' && !isCheckoutSubmit) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    setMessage(elements, 'Bitte bestätige zuerst die rechtlichen Hinweise.');
    elements.input.focus({ preventScroll: true });
    elements.root.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function bind() {
    const elements = getElements();
    if (!elements || !elements.input) return;

    const isNewBinding = elements.input.dataset.nettConsentBound !== 'true';
    if (isNewBinding) {
      elements.input.dataset.nettConsentBound = 'true';
      elements.input.addEventListener('change', handleChange);
    }

    if (elements.root.dataset.nettCartConsentReset === 'true') {
      resetStoredConsent(elements);
      return;
    }

    applyState({ saving: Boolean(saveRequest) });

    if (isNewBinding && window.__nhCartPropertiesReady?.finally) {
      window.__nhCartPropertiesReady.finally(() => applyState({ saving: Boolean(saveRequest) }));
    }
  }

  if (!window.__nettCartConsentGuardBound) {
    window.__nettCartConsentGuardBound = true;
    document.addEventListener('submit', guardCheckout, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }

  window.addEventListener('load', () => applyState({ saving: Boolean(saveRequest) }), { once: true });
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    const elements = getElements();
    if (!elements?.input) return;
    elements.input.checked = false;
    elements.root.dataset.nettCartConsentReset = 'true';
    resetStoredConsent(elements);
  });
  document.addEventListener('shopify:section:load', bind);
})();
